import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the user is on a mobile device
 * Uses multiple detection methods for accuracy:
 * - Screen width
 * - User agent
 * - Touch capability
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      // Method 1: Screen width check
      const isSmallScreen = window.innerWidth <= 768;

      // Method 2: User agent check
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobileUserAgent = mobileRegex.test(navigator.userAgent);

      // Method 3: Touch capability check
      const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      // Device is considered mobile if it meets at least 2 of the 3 criteria
      const mobileScore = [isSmallScreen, isMobileUserAgent, hasTouchScreen].filter(Boolean).length;
      setIsMobile(mobileScore >= 2);
    };

    // Check on mount
    checkIfMobile();

    // Add resize listener to handle orientation changes
    window.addEventListener('resize', checkIfMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return isMobile;
};

export default useIsMobile;
